import { IUpdateArquivoGenericoUseCase } from "../../../presentation/useCases/update/update_arquivo_generico_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

// UpdateArquivoGenericoUseCase


export class UpdateArquivoGenericoUseCase implements IUpdateArquivoGenericoUseCase
 {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async updateArquivoGenerico(
   IdArquivoGenerico1: number | null, IdArquivoGenerico2: number | null, IdArquivoGenerico3: number | null, IdTabela: number | null, NomeArquivo1: string | null, Arquivo1: string | null, NomeArquivo2: string | null, Arquivo2: string | null, NomeArquivo3: string | null, Arquivo3: string | null, Ordem: number | null, TipoTabela: number | null
  ): Promise<void> {
    
    await this.repository.updateArquivoGenerico(
     IdArquivoGenerico1, IdArquivoGenerico2, IdArquivoGenerico3, IdTabela, NomeArquivo1, Arquivo1, NomeArquivo2, Arquivo2, NomeArquivo3, Arquivo3, Ordem, TipoTabela
    );
  }
}
